'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.nodeDisplayNameMatches = undefined;

var _getComponentName = require('react-utils/getComponentName');

var _getComponentName2 = _interopRequireDefault(_getComponentName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @param {ReactElement} node
 * @param {RegExp} regex
 * @returns {Boolean} - true if the node has a displayName that matches the given regex
 */
var nodeDisplayNameMatches = exports.nodeDisplayNameMatches = function nodeDisplayNameMatches(node, regex) {
  return !!(node && (0, _getComponentName2.default)(node.type).match(regex));
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3620/js/core/ReactNodes.js
// module id = 536
// module chunks = 177